// extracted by mini-css-extract-plugin
export default {"loading":"Loader_loading__1uzh1","loading_wrapper":"Loader_loading_wrapper__JpEke","rotate":"Loader_rotate__QtzHw"};